import { render, staticRenderFns } from "./HeadImage.vue?vue&type=template&id=7130c7bf&scoped=true"
import script from "./HeadImage.vue?vue&type=script&lang=js"
export * from "./HeadImage.vue?vue&type=script&lang=js"
import style0 from "./HeadImage.vue?vue&type=style&index=0&id=7130c7bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130c7bf",
  null
  
)

export default component.exports